import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const location = useLocation();

  const [theme, setTheme] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tema') === 'istituzionale') return 'istituzionale';
    if (params.get('tema') === 'matrix') return 'matrix';
    const saved = localStorage.getItem('ai_covo_theme');
    if (saved) return saved;
    const host = window.location.hostname;
    if (host.endsWith('aicovo.it') || host === 'aicovo.it') return 'istituzionale';
    return 'matrix';
  });

  useEffect(() => {
    localStorage.setItem('ai_covo_theme', theme);
  }, [theme]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlTema = params.get('tema');
    if (urlTema === 'istituzionale') setTheme('istituzionale');
    else if (urlTema === 'matrix') setTheme('matrix');
  }, [location.search]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'matrix' ? 'istituzionale' : 'matrix');
  };

  const isInstitutional = theme === 'istituzionale';
  const isFormazione = location.pathname === '/formazione';
  const themeClass = isInstitutional ? (isFormazione ? 'theme-gov' : 'theme-mashup') : '';

  return (
    <ThemeContext.Provider value={{ theme, themeClass, isInstitutional, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
